function playlistControls() {
    let count = 0;
    const checkbox = $('.js-playlist-card-checkbox');
    const selectedNumber = $('.js-playlist-selected-videos-number');
    const deselectBtn = $('.js-playlist-deselect-all-btn');
    const selectAllCheckbox = $('.js-playlist-select-all-checkbox');

    const setDeselectBtnState = () => {
        count > 0
            ? deselectBtn.removeClass('dn-i')
            : deselectBtn.addClass('dn-i');
        // this for training-search-results-choose-delete.html page
        const deleteVideoBtn = $('.js-videos-to-delete-btn');
        if (deleteVideoBtn.length) {
            count > 0
                ? deleteVideoBtn.prop('disabled', false)
                : deleteVideoBtn.prop('disabled', true);
        }
    };

    const setSelectAllBtn = () => {
        count === checkbox.length
            ? selectAllCheckbox.prop('checked', true).prop('disabled', true)
            : selectAllCheckbox.prop('checked', false).prop('disabled', false);
    };

    checkbox.each(function () {
        count = $(this).prop('checked') ? count + 1 : count;
        selectedNumber.text(count);

        $(this).on('change', function () {
            if ($(this).prop('checked')) {
                count++;
            } else {
                count--;
            }
            selectedNumber.text(count);
            setDeselectBtnState();
            setSelectAllBtn();
        });
    });

    $(document).on('change', '.js-playlist-select-all-checkbox', function () {
        if ($(this).prop('checked')) {
            checkbox.prop('checked', true);
            count = checkbox.length;
        }
        selectedNumber.text(count);
        setDeselectBtnState();
        setSelectAllBtn();
    });

    deselectBtn.on('click', function () {
        checkbox.prop('checked', false);
        count = 0;
        selectedNumber.text(count);
        setDeselectBtnState();
        setSelectAllBtn();
    });

    setSelectAllBtn();
    setDeselectBtnState();
}
